import ReducerTypes from "../Types/ReducerTypes";

const INITIAL_STATE = {
  categories: [],
  businesses: {
    paginationData: {},
    items: [],
  },
  requestParams: {
    id: "",
    section: "category",
    filter: "",
    page: 1,
  },
};

function categoryReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ReducerTypes.CATEGORIES:
      return { ...state, categories: action.payload };
    case ReducerTypes.BUSINESSES_LIST: {
      return {
        ...state,
        businesses: {
          paginationData: action.payload.paginationData,
          items: action.payload.businesses,
        },
      };
    }
    case ReducerTypes.PARAMS: {
      const config = {};

      if (action.payload.hasOwnProperty("id")) {
        config.id = action.payload.id;
      }
      if (action.payload.hasOwnProperty("section")) {
        config.section = action.payload.section;
      }
      if (action.payload.hasOwnProperty("filter")) {
        config.filter = action.payload.filter;
      }
      if (action.payload.hasOwnProperty("page")) {
        config.page = action.payload.page;
      }
      return {
        ...state,
        requestParams: {
          ...state.requestParams,
          ...config,
        },
      };
    }
    default:
      return state;
  }
}
export default categoryReducer;
